<ng-container *ngIf="seq && seq.startTime">
    <div class="small gray font-italic px-1" *ngrxLet="testSeqInfo$ as testSeqInfo">
        <ng-container *ngIf="testSeqInfo && testSeqInfo.seqid == seq.dialerSeqId; else noTestSeqDoc">
            <div *ngIf="testSeqInfo.stats?.counts?.missing" class="bg-warning p-1 m-1 mb-0 rounded">
                {{testSeqInfo.stats.counts.missing}} call(s) not placed.
            </div>
            <div class="d-flex flex-row font-italic text-nowrap">
                <div *ngIf="testSeqInfo.dialerStatus == 'CANCELLED'"
                    class="text-warning font-weight-bold">
                    Manually Stopped
                </div>
                <div class="d-flex flex-row align-items-center">
                <div [ngSwitch]="testSeqInfo.status">
                    <div *ngSwitchCase="'DIALER_SEQ_FINISHED'" class="text-warning font-weight-bold">
                        Not Uploaded
                    </div>
                    <div *ngSwitchCase="'SEQ_FINISHED'" class="text-warning font-weight-bold">
                        Not Uploaded
                    </div>
                    <div *ngSwitchCase="'SERVER_ACCEPTED'" class="text-success font-weight-bold">
                        Uploaded
                    </div>
                    <div *ngSwitchCase="'SERVER_REJECTED'" class="text-danger font-weight-bold">
                        <i class="fa fa-exclamation-triangle mr-1"></i> Rejected
                    </div>
                    <div *ngSwitchCase="'SERVER_ERROR'" class="text-danger font-weight-bold">
                        <i class="fa fa-exclamation-triangle mr-1"></i> Rejected/Error
                    </div>
                    <div *ngSwitchDefault>
                        {{testSeqInfo.status?.split('_').join(' ')|ucwords}}
                        <div *ngIf="seq.stopTime && !testSeqInfo.endTime" class="small font-italic text-warning">
                            Dialer results not in sync
                        </div>
                    </div>
                </div>
                <button class="ml-1 mr-0 btn small-button btn-secondary"
                        title="View dialer result"
                        (click)="showDialerSeqId(seq,testSeqInfo)">
                    <i class="fa fa-info-circle smaller-text"></i>
                </button>
                </div>
            </div>
        </ng-container>
        <ng-template #noTestSeqDoc>
            <div *ngIf="seq.dialerSeqId" [attr.title]="'Dialer Seq ID: '+seq.dialerSeqId"
                    (click)="showDialerSeqId(seq,testSeqInfo)"
                    role="button" class="text-info font-italic font-weight-bold text-nowrap" >
                <i class="fa fa-mobile-alt mr-2"></i>{{seq.stopTime?'Dialer used':''}}
            </div>
            <div *ngIf="seq.startTime&&!seq.dialerSeqId" class="d-flex flex-row text-nowrap">
                <div class="fa-stack fa-1x text-secondary" style="margin-top:-4px;margin-left:-10px;">
                    <i class="fas fa-mobile-alt fa-stack-1x"></i>
                    <i class="fas fa-slash fa-stack-1x" style="opacity:.7;color:Tomato"></i>
                </div>
                Dialer not used
            </div>
        </ng-template>
    </div>
</ng-container>

